import clsx from 'clsx'
import * as React from 'react'
import { makeStyles } from 'tss-react/mui'
import { classToFComponent, FCClassContext, ToolbarDividerLegacy } from '../../../utils/views'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { HeaderScope } from '../up_scopes'

const useStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        alignSelf: 'stretch',
        gap: 5,
        marginLeft: 5
    },
    title: {
        color: '#6cea48',
        justifyContent: 'center'
    },
    subheader: {
        fontSize: 12
    }
}))

type HeaderProps = {
    className?: string
    scope: HeaderScope
}

class HeaderViewClass implements FCClassContext<HeaderProps> {
    // :: Fields

    scope!: HeaderScope

    // :: Emissors

    // <EMPTY>

    // :: Methods

    onSyncState({ scope }: HeaderProps) {
        this.scope = scope
    }

    render(props: HeaderProps): React.JSX.Element {
        const classes = useStyles().classes

        return (
            <div className={clsx(classes.view, props.className)}>
                <ToolbarDividerLegacy orientation="vertical" variant="middle" flexItem />
                <Stack className={classes.title}>
                    <Typography variant="h5">Perfil</Typography>
                </Stack>
            </div>
        )
    }
}
export const HeaderView = classToFComponent(HeaderViewClass, React)
export default HeaderView
